import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { deleteSession } from '../../core/services/storage.service';

@Component({
  selector: 'ltg-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    deleteSession();
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/logout/logout.component.ts